module.exports = __webpack_public_path__ + "sofa.29eeb9c7.png";